import { MessageSquare } from "lucide-react";
import { DISCORD_URL, LOGO_URL } from "@/data/servers";

export const Header = () => (
  <header className="fixed top-0 inset-x-0 z-30 bg-black/80 backdrop-blur-xl border-b border-white/5">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
      <div className="flex items-center gap-3" data-testid="brand-logo">
        <img src={LOGO_URL} alt="BRASIL+" className="w-11 h-11 object-contain" data-testid="site-logo" />
        <span className="dz-heading text-xl font-extrabold uppercase tracking-wider text-zinc-100">
          DayZ <span className="text-[#e02424]">Brasil+</span>
        </span>
      </div>
      <a
        href={DISCORD_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="header-discord-button"
        className="dz-heading uppercase tracking-wider font-bold text-sm flex items-center gap-2 px-4 py-2 bg-[#5865F2] text-white hover:bg-[#4752c4] transition-colors"
      >
        <MessageSquare size={16} /> Discord
      </a>
    </div>
  </header>
);
